import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { NoteModalOptionsModel } from './models/modal.note.options';

@Component({
  selector   : 'wor-note-modal',
  template: require('./modal.note.component.html')
})
export class NoteModalComponent {

  @Input() options : NoteModalOptionsModel;

  constructor(
    public activeModal: NgbActiveModal
  ) {}
}
